
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/rasayel",
      function () {
        return require("private-next-pages/alternatives/rasayel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/rasayel"])
      });
    }
  